import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import CountUp from "react-countup";
import {
  faInstagram,
  faFacebookF,
  faLinkedinIn,

} from "@fortawesome/free-brands-svg-icons";
import axios from 'axios';
import { Helmet } from "react-helmet";

import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./Menu/global";
import { theme } from ".//Menu/theme";
import Typed from 'react-typed';
import {Link} from 'react-router-dom'
import { Link  as Link1} from "react-scroll";
import Fade from "react-reveal/Fade";
import { Formik } from "formik";

import "animate.css/animate.css";
import Menu from "./Menu/Menu";
import Burger from "./Menu/Burger";

function HomeAr() {
  // style
  const [open, setOpen] = useState(false);
  const history = useHistory();

  const [sticky, setSticky] = useState({ isSticky: false, offset: 0 });
  const headerRef = useRef(null);
  const [thank,setThank]= useState(false);

  const [error,setError]= useState(false);

  // handle scroll event
  const handleScroll = (elTopOffset, elHeight) => {
    if (window.pageYOffset > elTopOffset + elHeight) {
      setSticky({ isSticky: true, offset: elHeight });
    } else {
      setSticky({ isSticky: false, offset: 0 });
    }
  };


  // scroll to the section by updating url 
const [isLoading, setIsLoading] = useState(true);


useEffect(
  () => {
    var currentUrl = window.location.hash
    if(isLoading){
      if(currentUrl!=="") {
console.log('ffffff')
return( 
  
  window.scrollTo({
  behavior: "smooth",
  top: document.getElementById(currentUrl.replace("#", "")).offsetTop
}))
       
      }   else{
  
        return
      }

    }

  },
  [isLoading]
  );

  // add/remove scroll event listener
  useEffect(() => {
    var header = headerRef.current.getBoundingClientRect();
    const handleScrollEvent = () => {
      handleScroll(header.top, header.height);
    };

    window.addEventListener("scroll", handleScrollEvent);

    return () => {
      window.removeEventListener("scroll", handleScrollEvent);
    };
  }, []);

  // router
  function handleClick(e, path) {
    e.preventDefault();
    window.open(path, '_blank') 
  }

  // send data
  const initialValues = {
    name: "",
    phone: "",
    email: "",
    msg: "",
  };
  const validate = (values) => {
    let errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    const regexName = /\d/
    const regexPhone = /^[0-9]*$/

    if (!values.email) {
      errors.email = " قم بادخال الايميل";
    } else if (!regex.test(values.email)) {
      errors.email = "الايميل غير صحيح";
    }
    if (!values.name) {
      errors.name = " قم بادخال الاسم";
    } else if (regexName.test(values.name)==true) {
      errors.name = "الاسم غير صحيح";
    }
    if (!values.phone) {
      errors.phone = " قم بادخال رقم الهاتف";
    } else if (!regexPhone.test(values.phone)) {
      errors.phone = "رقم الهاتف غير صحيح";
    }
    if (!values.msg) {
      errors.msg = "قم بادخال الرساله";
    } 
    return errors;
  };


  const submitForm = async (values , actions) => {
    console.log(document.querySelector('[type="submit"]')[0])
    document.querySelector('[type="submit"]').classList.add("disabled-btn")

    let response = await  axios.post(`http://178.79.135.126:5433/guest/guest_contact_us`, { 
     name:values.name,
        email:values.email,
        phone:values.phone,
       message:values.msg   
     })
    .then(res => {
      
      document.querySelector('[type="submit"]').classList.remove("disabled-btn")

      actions.resetForm({
        values: {
          name: "",
          phone: "",
          email: "",
          msg: "",
         }
        })
        setThank(true)
    })
    .catch((err)=>{
      setError(true)  
      document.querySelector('[type="submit"]').classList.remove("disabled-btn")
  

    }
      
    )




  };





  
  return (
    <div>
     <Helmet>
                <meta charSet="utf-8" />
                <title>Nos-Wazeefa arabic </title>
                <link
                  rel="canonical"
                  href="http://noswazeefa.net/ar"
                />
            </Helmet>

   
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyles />

        <div className='arabic'>
          <div id="menu_mobile">
            <Burger open={open} setOpen={setOpen} />
            <Menu open={open} setOpen={setOpen} />
          </div>
          <header id="Home">
            <nav
              id="sticky-header"
              className={`navbar${sticky.isSticky ? " sticky" : "notsticky"}`}
              ref={headerRef}
            >
              <div>
                <div className="logo">
                  <img src={require("../assets/images/logo.png")} alt="logo" />
                </div>
                <div className="list">
                  <ul>
                    <li>
                      <Link1
                        to="Home"
                        spy={true}
                        smooth={true}
                        offset={50}
                        duration={500}
                      >
                        الرئيسية
                      </Link1>
                    </li>
                    <li>
                      <Link1
                        to="Features"
                        spy={true}
                        smooth={true}
                        offset={50}
                        duration={500}
                      >
                        حمل التطبيق
                      </Link1>
                    </li>

                    <li>
                      <Link1
                        to="Company"
                        spy={true}
                        smooth={true}
                        offset={50}
                        duration={500}
                      >
                      الشركات
                      </Link1>
                    </li>
                    <li>
                      <Link
                        to="/privacy_ar"
                        rel="canonical"
                                                spy={true}
                        smooth={true}
                        offset={50}
                        duration={500}
                      >
                        السياسه و الخصوصيه 
                      </Link>

                    </li>
                    <li>
                      <Link1
                        to="Contact"
                        spy={true}
                        smooth={true}
                        offset={50}
                        duration={500}
                      >
       
                    
                     تواصل معنا
                      </Link1>
                    </li>
                    <li>
                      <Link  rel="canonical" to='/' className="ar" >
                      
                      الانجليزيه
                      </Link>
                    </li>
                    
                  </ul>
                </div>
              </div>
            </nav>
            <div className="header_left">
              
              <h2>
                
              تطبيق نص وظيفة
               

               <span>   <Typed
                    strings={['تطبيق نص وظيفة حلقة الوصل الأقوى بين الشباب السعودي الباحث عن فرص عمل بدوام جزئي و بين أكبر الشركات السعودية']}
                    typeSpeed={40} 
                    startDelay={200}
                />
                </span>
              </h2>

              <p className="img animate__fadeInRight icon animated  animate__animated   ">
            
              
              عملية توظيف مريحة وسهلة للغاية 
              <br/>
              <br/>           
              قم بالتسجيل على موقع نص وظيفة، وإنشاء حساب خاص لشركتك وأكتشف المزايا الرائعة لعملية التوظيف مع نص وظيفه              </p>
              <div className="download_btn">
                <button>
                  <a href={process.env.PUBLIC_URL +('nos-wazeefa_arabic_profile.pdf')} download>
                  <span>
                    <span>تحميل </span>
                    <br />
                    الملف التعريفى   
                    
                                   </span>
                                   <FontAwesomeIcon icon={faDownload} />
                                   </a>

                </button>
                <button onClick={(e) =>
                    handleClick(
                      e,
                      "http://company.noswazeefa.net/#/"
                    )
                  }>
                  <span>
                    <span>سجل الآن
                        </span>
                    <br />
                    مع نص وظيفة
                                      </span>{" "}
                  <FontAwesomeIcon icon={faChevronRight} />
                </button>
              </div>
            </div>
            <div className="header_right img animate__fadeInLeft icon animated  animate__animated  ">
              <div className="img  icon ">
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 866.526 1083.998"
                   preserveAspectRatio="none"
                >
                  <defs>
                    <linearGradient
                      id="linear-gradient"
                      x1="0.61"
                      y1="1"
                      x2="0.39"
                      gradientUnits="objectBoundingBox"
                    >
                      <animate
                        attributeName="y2"
                        repeatCount="indefinite"
                        dur="2.7777777777777772s"
                        keyTimes="0;0.5;1"
                        values="-0.08;0.08;-0.08"
                        keySplines="0.5 0 0.5 1;0.5 0 0.5 1"
                        calcMode="spline"
                      ></animate>
                      <stop stopColor="#044da2" offset="0"></stop>
                      <stop stopColor="#d56708" offset="1"></stop>
                    </linearGradient>
                  </defs>
                  <g
                    id="Shape_1"
                    data-name="Shape 1"
                    className="cls-1"
                    transform="translate(-1056.474 2.999)"
                  >
                    <path
                      className="cls-2"
                      d="M 1922.49853515625 1080.260498046875 C 1920.47265625 1079.465209960938 1913.898681640625 1076.976806640625 1901.296508789063 1073.010864257813 C 1887.057250976563 1068.529663085938 1861.974487304688 1061.18603515625 1823.343872070313 1051.64990234375 C 1779.930908203125 1040.93310546875 1728.603393554688 1029.687133789063 1670.786865234375 1018.224304199219 C 1598.519775390625 1003.896606445313 1515.851928710938 989.1875 1425.079711914063 974.5056762695313 C 1402.0634765625 970.7828369140625 1379.77294921875 966.1295166015625 1358.827514648438 960.6747436523438 C 1338.674926757813 955.4265747070313 1319.223388671875 949.2947387695313 1301.012939453125 942.4497680664063 C 1283.534545898438 935.8800659179688 1266.729370117188 928.4764404296875 1251.064086914063 920.4447021484375 C 1236.069946289063 912.7571411132813 1221.718383789063 904.2882080078125 1208.408203125 895.2731323242188 C 1195.708251953125 886.67138671875 1183.61767578125 877.343017578125 1172.472045898438 867.5472412109375 C 1161.87646484375 858.2347412109375 1151.853881835938 848.2527465820313 1142.682739257813 837.8786010742188 C 1134.00146484375 828.05859375 1125.8544921875 817.6284790039063 1118.4677734375 806.877685546875 C 1111.511596679688 796.753662109375 1105.0478515625 786.0804443359375 1099.255859375 775.1546020507813 C 1093.8359375 764.9306030273438 1088.863525390625 754.2197875976563 1084.476684570313 743.3199462890625 C 1080.404296875 733.2009887695313 1076.731689453125 722.658203125 1073.560791015625 711.984619140625 C 1068.005004882813 693.2820434570313 1063.79296875 673.524169921875 1061.041870117188 653.259765625 C 1058.859619140625 637.1838989257813 1057.584838867188 621.0313720703125 1057.144653320313 603.8792724609375 C 1056.776245117188 589.519287109375 1057.086303710938 577.5079345703125 1057.312622070313 568.737548828125 C 1057.411499023438 564.8994750976563 1057.497192382813 561.583984375 1057.499755859375 559.0086059570313 C 1058.033081054688 545.3483276367188 1059.7802734375 529.9635620117188 1062.692993164063 513.2816772460938 C 1065.877319335938 495.0437927246094 1070.385864257813 475.7099304199219 1076.093627929688 455.817138671875 C 1082.367797851563 433.9496459960938 1090.0732421875 411.4927368164063 1098.99609375 389.0703125 C 1108.779663085938 364.4847412109375 1120.117065429688 339.7254028320313 1132.693603515625 315.4801940917969 C 1161.382080078125 260.1739196777344 1196.693359375 207.0264587402344 1237.64697265625 157.5139312744141 C 1248.846923828125 143.9731292724609 1260.624755859375 130.5276641845703 1272.652954101563 117.5508575439453 C 1285.109985351563 104.1112594604492 1298.176513671875 90.80699157714844 1311.489501953125 78.00765991210938 C 1325.256958007813 64.77112579345703 1339.666748046875 51.71059417724609 1354.318481445313 39.18859481811523 C 1369.408081054688 26.29237937927246 1385.170288085938 13.61215305328369 1401.169311523438 1.498120188713074 L 1920.500732421875 -2.49513840675354 L 1922.49853515625 1080.260498046875 Z"
                    />
                    <path
                      className="cls-3"
                      d="M 1921.997192382813 1079.529541015625 L 1920.001708984375 -1.991371512413025 L 1401.338989257813 1.996845006942749 C 1385.39306640625 14.07471752166748 1369.683837890625 26.71439552307129 1354.643310546875 39.56872940063477 C 1339.9990234375 52.08439254760742 1325.5966796875 65.13839721679688 1311.8359375 78.36805725097656 C 1298.530029296875 91.16089630126953 1285.470336914063 104.4582290649414 1273.019653320313 117.8907241821289 C 1260.997802734375 130.8607330322266 1249.226318359375 144.2990570068359 1238.032104492188 157.8325653076172 C 1197.101318359375 207.3179016113281 1161.809448242188 260.435546875 1133.137451171875 315.7103881835938 C 1120.568603515625 339.9410705566406 1109.238159179688 364.68505859375 1099.460693359375 389.2552185058594 C 1090.5439453125 411.6622314453125 1082.84375 434.1033935546875 1076.574096679688 455.9550476074219 C 1070.871459960938 475.8309020996094 1066.366821289063 495.147216796875 1063.185424804688 513.3675537109375 C 1060.277221679688 530.0234375 1058.53271484375 545.3816528320313 1057.999755859375 559.017333984375 C 1057.996948242188 561.597900390625 1057.911376953125 564.9130249023438 1057.8125 568.7505493164063 C 1057.586303710938 577.5155639648438 1057.276489257813 589.51953125 1057.644653320313 603.8665771484375 C 1058.084350585938 621.0003662109375 1059.357666015625 637.13525390625 1061.537475585938 653.19287109375 C 1064.28515625 673.431884765625 1068.491577148438 693.1643676757813 1074.040283203125 711.8424072265625 C 1077.206665039063 722.501220703125 1080.874145507813 733.0288696289063 1084.940795898438 743.1334228515625 C 1089.320922851563 754.0172119140625 1094.286010742188 764.7120361328125 1099.69775390625 774.9205322265625 C 1105.48095703125 785.8297119140625 1111.934814453125 796.4863891601563 1118.880126953125 806.5947265625 C 1126.255249023438 817.3287353515625 1134.389770507813 827.7427368164063 1143.0576171875 837.5475463867188 C 1152.21484375 847.9060668945313 1162.222412109375 857.873046875 1172.80224609375 867.1717529296875 C 1183.93212890625 876.9537353515625 1196.006103515625 886.2692260742188 1208.688598632813 894.8592529296875 C 1221.982299804688 903.8629150390625 1236.316162109375 912.321533203125 1251.292358398438 919.9998779296875 C 1266.940673828125 928.0228881835938 1283.728271484375 935.418701171875 1301.18896484375 941.9817504882813 C 1319.382934570313 948.820556640625 1338.817749023438 954.9470825195313 1358.953491210938 960.19091796875 C 1379.8837890625 965.6417236328125 1402.158813476563 970.2918701171875 1425.159423828125 974.0120849609375 C 1515.9375 988.6948852539063 1598.611083984375 1003.404907226563 1670.883911132813 1017.73388671875 C 1728.708129882813 1029.1982421875 1780.04345703125 1040.445922851563 1823.463745117188 1051.164428710938 C 1862.10693359375 1060.703735351563 1887.200439453125 1068.050537109375 1901.446655273438 1072.533935546875 C 1912.885375976563 1076.1337890625 1919.370727539063 1078.5205078125 1921.997192382813 1079.529541015625 M 1923 1080.999267578125 C 1923 1080.999267578125 1822.930908203125 1039.362060546875 1424.999755859375 974.9992065429688 C 1027.06884765625 910.6360473632813 1056.953002929688 608.0945434570313 1056.999755859375 558.9990844726563 C 1061.06884765625 454.6385498046875 1138.930786132813 199.3617248535156 1400.999755859375 0.9993943572044373 L 1920.999755859375 -2.99910569190979 L 1923 1080.999267578125 Z"
                    />
                  </g>
                </svg> */}
              </div>

              <img
                className=" animate__fadeIn icon animated  animate__animated "
                src={require("../assets/images/arabic/mobile.png")}
              />

              <div className="social_icons">
                <a href="https://www.instagram.com/noswazeefa/" target="_blank">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a href="https://www.facebook.com/noswazeefasa/" target="_blank">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a href="https://www.linkedin.com/company/noswazeefa/?viewAsMember=true" target="_blank">
                  {" "}
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
              </div>
            </div>
          </header>

          <main>
            <section
              data-aos="fade-up"
              data-aos-duration="3000"
              className="features"
              id="Features"
            >
              <div className="text">
                <Fade>
                  <h3 >تبحث عن وظيفتك المثالية بدوام جزئي؟</h3>
                </Fade>
                <Fade bottom>
                  <p>
                  قم بتنزيل تطبيق نص وظيفة، وأكتشف المزيد من الوظائف الرائعة والمناسبة لك حسب خبراتك ومؤهلاتك
                  </p>
                  <div className="buttons apple_google">
                    <button
                      onClick={(e) =>
                        handleClick(
                          e,
                          "https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en"
                        )
                      }
                    >
                      {/* <span>
                        {" "}
                        <span>أحصل عليه من </span> <br />متجر جوجل
                      </span>
                      <FontAwesomeIcon icon={faGooglePlay} /> */}
                                        <img src={require("../assets/images/google.png")} alt=''/>


                    </button>
                    <button
                      onClick={(e) =>
                        handleClick(
                          e,
                          "https://apps.apple.com/gb/app/noswazeefa/id1491881612?l=nb"
                        )
                      }
                    >
                      {/* <span>
                        <span>أحصل عليه من</span> <br />
                        متجر آبل
                                         
                                              </span>
                                              <FontAwesomeIcon icon={faApple} /> */}
                             <img src={require("../assets/images/apple.png")} alt=''/>


                    </button>
                  </div>
                </Fade>
              </div>
              <img src={require("../assets/images/featuresImgar.png")} />

              <svg width="0" height="0">
                <radialGradient id="rg" r="150%" cx="30%" cy="107%">
                  <stop stopColor="#115db4" offset="0" />
                  <stop stopColor="#f58220" offset="1" />
                </radialGradient>
              </svg>
              <Fade bottom>
                <div className="grid">
                  <div>
                    <figure>
                      <img src={require("../assets/images/cv.png")} />
                    </figure>
                    <figcaption>قم بالتسجيل على تطبيق نص وظيفة</figcaption>
                  </div>
                  <div>
                    <figure>
                      <img src={require("../assets/images/bag.png")} />
                    </figure>
                    <figcaption>انشيء ملفك الخاص</figcaption>
                  </div>{" "}
                  <div>
                    <figure>
                      <img src={require("../assets/images/lens.png")} />
                    </figure>
                    <figcaption>استفد من العديد من المزايا الرائعة</figcaption>
                  </div>{" "}
                  <div>
                    <figure>
                      <img src={require("../assets/images/hand.png")} />
                    </figure>
                    <figcaption>قم بقبول أو رفض عروض التوظيف من الشركات</figcaption>
                  </div>
                </div>
              </Fade>
            </section>
          </main>
          <Fade>
            <h3>إحصائياتنا</h3>
          </Fade>

          <section
            data-aos="fade-up"
            data-aos-duration="3000"
            className="static"
          >
            <div className="grid">
              <div>
                <img src={require("../assets/images/employee.png")} />

                <h4>
                  {" "}
                  <CountUp end={4687} start={1000} delay={5} duration={10} />
                </h4>

                <h4>مستخدم</h4>
              </div>
              <div>
                <img src={require("../assets/images/downarrow.png")} />
                <h4>
                  {" "}
                  <CountUp end={500} start={0} delay={5} duration={10} />k
                </h4>

                <h4>تـنـزيـلات</h4>
              </div>
              <div>
                <img src={require("../assets/images/verified.png")} />
                <h4>
                  {" "}
                  <CountUp end={750} start={0} delay={5} duration={8} />
                </h4>
                                <h4>قـائـد</h4>
              </div>
              <div>
                <img src={require("../assets/images/5stars.png")} />
                <h4>
                  {" "}
                  <CountUp end={3000} start={100} delay={5} duration={10} />
                </h4>

                <h4>أعلى تقييم</h4>
              </div>
            </div>
          </section>
          <section
            data-aos="fade-up"
            data-aos-duration="3000"
            className="company"
            id="Company"
          >
            <Fade>
              <h3>مزايا للشركات</h3>
            </Fade>
            <div className="flex">
              <Fade left>
                <div>
                  <img src={require("../assets/images/arabic/lab.png")} />
                </div>
              </Fade>
              <Fade right>
                <ul>
                  <li>
                    {" "}
                    <img
                      className="icon animated  animate__animated   animate__infinite	infinite"
                      src={require("../assets/images/cloud-computing.png")}
                    />
                    <span>قم ببناء حساب شركتك</span>
                  </li>
                  <li>
                    {" "}
                    <img
                      className="icon"
                      src={require("../assets/images/badge.png")}
                    />
                    <span>قم بنشر أول وظيفة / مشروع</span>
                  </li>

                  <li>
                    {" "}
                    <img
                      className="icon"
                      src={require("../assets/images/profile.png")}
                    />
                    <span>اختر من بين آلاف الشباب السعودي المتاح للعمل</span>
                  </li>

                  <li>
                    <img
                      className="icon"
                      src={require("../assets/images/computer.png")}
                    />
                    <span>قم بقبول أو رفض طلبات التقدم للوظيفة</span>
                  </li>
                  <li>
                    <button className="button" onClick={(e) =>
                    handleClick(
                      e,
                      "http://company.noswazeefa.net/#/"
                    )
                  }>
                      <span>
                      سجل الآن<FontAwesomeIcon icon={faChevronRight} />{" "}
                      </span>
                    </button>
                  </li>
                </ul>
              </Fade>
            </div>
          </section>
          { (thank==false&&error==false) &&
          <section
            data-aos="fade-up"
            data-aos-duration="3000"
            className="contact"
            id="Contact"
          >
            <Fade bottom>
              <h5>تحتاج لاستشارة من فريقنا المختص؟</h5>
            </Fade>
            <Fade bottom>
              <h4>قم بالتواصل معنا الآن .وسنقوم بالرد على استفساراتك</h4>
            </Fade>
            <Fade>
            <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={submitForm}
    >
      {(formik) => {
        const {
          values,
          handleChange,
          handleSubmit,
          errors,
          touched,
          handleBlur,
          isValid,
          dirty
        } = formik;
  return (
              <form onSubmit={handleSubmit}>
                <div>
                  <div>
                  <input
                   type="text"
                   placeholder='الاسم'
                   name="name"
                   id="name"
                   value={values.name}
                   onChange={handleChange}
                   onBlur={handleBlur}
                   className={errors.name && touched.name ? 
                   "input-error" : null}
                />
 {errors.name && touched.name && (
                    <span className="error">{errors.name}</span>
                  )}
</div>
                  <br />
                  <div>

                  <input
                   type="phone"
                   name="phone"
                   id="phone"
                   placeholder='رقم الهاتف'
                   value={values.phone}
                   onChange={handleChange}
                   onBlur={handleBlur}
                   className={errors.phone && touched.phone ? 
                   "input-error" : null}
                />
 {errors.phone && touched.phone && (
                    <span className="error">{errors.phone}</span>
                  )}
</div>
                  <br />
                </div>
                <input
                   type="email"
                   name="email"
                   id="email"
                   placeholder='البريد الالكترونى'
                   value={values.email}
                   onChange={handleChange}
                   onBlur={handleBlur}
                   className={errors.email && touched.email ? 
                   "input-error" : null}
                />
 {errors.email && touched.email && (
                    <span className="error">{errors.email}</span>
                  )}
                <textarea
                   type="text"
                   name="msg"
                   id="msg"
                   placeholder='الرساله'
                   value={values.msg}
                   onChange={handleChange}
                   onBlur={handleBlur}
                   className={errors.msg && touched.msg ? 
                   "input-error" : null}
                />
 {errors.msg && touched.msg && (
                    <span className="error">{errors.msg}</span>
                  )}

                <br />
                <button  type="submit"
                  className={dirty && isValid ? "button" : "button disabled-btn"}
                  disabled={!(dirty && isValid)}>
                  {" "}
                  <span>
                ارسال<FontAwesomeIcon icon={faChevronRight} />
                  </span>
                </button>
              </form>
     
     
     );
    }}
         </Formik>       
         </Fade>
          </section>



        }


{ (thank==true&&error==false) &&

  <section id="result" className="animate__zoomIn  animated  animate__animated">
<img src={require("../assets/images/resulticon.png")} alt=''/>
<p className="grdtxt">شكرا لتواصلكم معنا !</p>
<p>سيتم الرجوع اليكم قريبا</p>
</section>

}
{ (thank==false&&error==true) &&

<section id="result" className="animate__zoomIn  animated  animate__animated">
<img src={require("../assets/images/error.png")} alt=''/>
<p className="grdtxt">عذرا حدث خطا ما !</p>
<p>يرجى إعادة المحاولة لاحقا</p>
</section>

}




          <footer>
            <div>
            <Fade bottom>
              <h4>
              حمل تطبيقنا الآن 
             <br /> للحصول على فرص غير متناهية 
              </h4>
              </Fade>
              <div className="buttons apple_google">
                <button
                  onClick={(e) =>
                    handleClick(
                      e,
                      "https://play.google.com/store/apps/details?id=com.joe13th.noswazeefa&hl=en"
                    )
                  }
                >
            
                                    <img src={require("../assets/images/google.png")} alt=''/>


                </button>
                <button
                  onClick={(e) =>
                    handleClick(
                      e,
                      "https://apps.apple.com/gb/app/noswazeefa/id1491881612?l=nb"
                    )
                  }
                >

                  <img src={require("../assets/images/apple.png")} alt=''/>

                </button>
              </div>
            </div>

            <div className="bot_page">
              <p>
                © كل الحقوق محفوظه 2020| 
               تم العمل بواسطه{" "}
                <span>
                  <a href="https://natsaudi.net/" target="_blank">NAT</a>
                </span>{" "}
                |  <Link  rel="canonical" to='privacy_ar'>السياسه و الخصوصيه</Link>
              </p>

              <div className="social_icons">
                <a href="https://www.instagram.com/noswazeefa/" target="_blank">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a href="https://www.facebook.com/noswazeefasa/" target="_blank">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
                <a href="https://www.linkedin.com/company/noswazeefa/?viewAsMember=true" target="_blank">
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
              </div>
            </div>
          </footer>
        </div>
      </>
    </ThemeProvider>
    </div>
  );
}
export default HomeAr;
